module.exports = __webpack_public_path__ + "static/cooking-demo.ca5cd231.jpg";